import React, { useEffect } from "react";

import AccountLayout from "components/layout/AccountLayout";
import ProfileForm from "features/account/ProfileForm";
import PasswordForm from "features/account/PasswordForm";

export function Profile() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <AccountLayout title="My profile">
      <ProfileForm />
    </AccountLayout>
  );
}

export function Password() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <AccountLayout title="Password">
      <PasswordForm />
    </AccountLayout>
  );
}
